import React from 'react';
import { Globe, Loader2 } from 'lucide-react';

export const WebSearchToggle = ({ enabled, onToggle, isSearching = false }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      data-testid="web-search-toggle"
      className={`
        flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium
        transition-all duration-200 
        ${enabled 
          ? 'web-search-pill active text-[#D97757]' 
          : 'web-search-pill text-[#596059] hover:text-[#1A1D1A]'
        }
      `}
    >
      {isSearching ? (
        <Loader2 className="w-3.5 h-3.5 animate-spin" />
      ) : (
        <Globe className="w-3.5 h-3.5" />
      )}
      <span>{isSearching ? 'Searching...' : 'Web'}</span>
    </button>
  );
};

export default WebSearchToggle;
